import React from 'react';
import { connect } from 'react-redux';

import { Icon, Typography } from '@americanexpress/aqx-components';

import styles from './index.scss?modules';

import {
  getViewMyAccountSubData,
  appendRedirectQuery
} from 'page_modules/business-page-containers/templates/view-my-account';
import { isLoggedInCardMember } from 'src/universal/redux/userType';
import { isCardMember } from 'src/universal/redux/userType';
import { mapUrlWithDtmLinkQuery } from 'service_modules/models/dtm-tagging';

const MobileFilter = ({ viewMyAccountSubData, isUserLoggedIn, isCardMember }) => {
  const showViewMyAccountSub =
    Object.keys(viewMyAccountSubData || {}).length > 0 &&
    isUserLoggedIn &&
    isCardMember;

  if (!showViewMyAccountSub) return null;
  const { url, dtmTag, imageName, header } = viewMyAccountSubData;
  const accountUrl = mapUrlWithDtmLinkQuery(url ?? '', dtmTag ?? {});

  return (
    <div className={styles.viewMyAcct}>
      <button onClick={() => (window.location.href = accountUrl)}>
        <Icon className={styles.icon} directory="dls" imageName={imageName} />
        <Typography className={styles.text}>{header}</Typography>
      </button>
    </div>
  );
};
const mapStateToProps = state => {
  return {
    viewMyAccountSubData: appendRedirectQuery(getViewMyAccountSubData(state)),
    isUserLoggedIn: isLoggedInCardMember(state),
    isCardMember: isCardMember(state)
  };
};

export default connect(mapStateToProps)(MobileFilter);
